import * as angular from 'angular';

"use strict";

angular.module('ValidatorsModule', [])

export default 'ValidatorsModule';